import React, {Component} from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router,Route} from 'react-router-dom'
import {MenuItem }       from 'react-bootstrap';
import $                 from 'jquery'; 
import TopoPrefessor     from '../topo/topo_professor';
import Home              from './home';
import Batalha           from '../batalha/batalha_professor';
import Equipe            from '../equipe/equipe_professor';
import EquipeTurma       from '../equipe/equipe_professor_turma';
import EquipeAluno       from '../equipe/equipe_professor_turma_aluno';
import Timeline_Equipe   from '../timeline_equipe/timeline_equipe';
import Timeline_Turma   from '../timeline_turma/timeline_turma';
import Jogo              from '../../jogos/jogo';
import JogosG            from '../../jogos/jogosG';
import Questao           from '../questao/questao';
import Desafios          from '../desafios/desafios_professor';
import DesafiosProfessorDisciplina          from '../desafios/desafios_professor_disciplina';
import DesafiosCadastro  from '../desafios/form/desafios_cadastro';
import DesafiosEditar    from '../desafios/form/desafios_editar';
import DesafiosDuplicar    from '../desafios/form/desafios_duplicar';
import DesempenhoAluno   from '../desafios/desafios_desempenho_aluno';
import DesafioBomba      from '../desafios/bomba/desafios_bomba';
import DesafioBombaAction      from '../desafios/bomba/desafios_bomba_form';
import DesafioQuiz       from '../desafios/quiz/desafios_quiz';
import DesafioQuizAction       from '../desafios/quiz/desafios_quiz_form';
import DesafioSenha      from '../desafios/senha/desafios_senha';
import DesafioSenhaAction      from '../desafios/senha/desafios_senha_form';
import DesafioJogos      from '../../jogos/desafios_jogos';
import MissaoProfessorDisciplina   from '../missoes/missao_professor_disciplina';
import MissaoCadastro     from '../missoes/missao_cadastro';
import MissaoEditar       from '../missoes/missao_editar';
import MissaoResposta     from '../missoes/missao_resposta';
import MissaoLista        from '../missoes/missao_professor';
import Relatorio          from '../relatorios/relatorio';
import RankingAluno       from '../relatorios/ranking_aluno';
import RankingTurma       from '../relatorios/ranking_turma';
import Recursos           from '../recursos/recursos';
import MenuSideBar        from '../menu/menu_sidebar';
import MenuTopo           from '../menu/menu_topo';
import MenuSub            from '../menu/menu_sub';
import Perfil             from '../perfil/perfil';
import { GetCheckSelect } from '../../../actions/scopoAction';
import LinkContainer        from '../../../container/LinkContainer';
import '../../../css/professor/styleProHome.css'
import '../../../css/bootstrap.css'
import '../../../css/style.css'
import '../../../css/fonte-gamifica.css';

class home_professor extends Component {


  handleSelect(key) {
    this.props.logout();
}

  render() {
    $('.menu a').removeClass('active');
    $('.menu a').on('click', function() {
      $('a').removeClass('active');
      $(this).addClass('active');
    });

    $(`.btn-action-${this.props.checkSelect}`).addClass('active');
    


    return (
       <Router basename={this.props.menu.raiz}>
        <div>
         <TopoPrefessor/> 
          <div id="wrapper" className="">
            <div id="sidebar-wrapper">
              <div className="perfilMenuSidebar visible-xs">
              <div className="dropdown">
              <div className="media" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
              <div className="media-left">
                  <img className="media-object img-circle" src={this.props.session.foto} alt=''/>
               </div>
              <div className="media-body">
                <h4 className="media-heading">{this.props.session.nome}<span className="caret"></span></h4>
               
              </div>
            </div>
              <ul className="dropdown-menu" aria-labelledby="dropdownMenu1">
              <LinkContainer to={this.props.menu.perfil.home}>
              <MenuItem><span className="glyphicon glyphicon-user"></span> <b>Perfil</b></MenuItem>
            </LinkContainer>
            <LinkContainer to="/login" onClick = {this.handleSelect.bind(this)}>
              <MenuItem><span className="glyphicon glyphicon-log-in"></span> <b>Sair</b></MenuItem>
            </LinkContainer>
              </ul>
            </div>
     

              </div>
              <ul className="sidebar-nav" id="sidebar">
                <MenuSideBar/>
              </ul>
          </div>
          <div id="page-content-wrapper">
          <MenuTopo/> 
          <MenuSub/>
            <div className="container">              
               <Route exact path={this.props.menu.home}                                         component={Home}/>
               <Route path={this.props.menu.batalha.professor.home}                             component={Batalha}/>
               <Route path={this.props.menu.equipe.professor.home}                              component={Equipe}/>
               <Route path={`${this.props.menu.equipe.professor.equipe_turma}/:tur_id/:dis_id`} component={EquipeTurma}/>
               <Route path={`${this.props.menu.equipe.professor.turma_aluno}/:id/:id2/:id3`}    component={EquipeAluno}/>
               <Route path={`${this.props.menu.equipe.professor.timeline_equipe}/:id`}          component={Timeline_Equipe}/>
               <Route path={`${this.props.menu.turma.professor.timeline_turma}/:id`}            component={Timeline_Turma}/>
               <Route path={`${this.props.menu.jogo}/:id`}                                      component={Jogo}/>
               <Route path={this.props.menu.jogos.home}                                         component={JogosG}/>
               <Route path={this.props.menu.desafios.home}                                      component={DesafiosProfessorDisciplina}/>
               <Route path={`${this.props.menu.desafios.desafio_turma}/:tur_id/:dis_id`}        component={Desafios}/>
               <Route path={this.props.menu.desafios.novo}                                      component={DesafiosCadastro}/>
               <Route path={`${this.props.menu.desafios.editar}/:id`}                           component={DesafiosEditar}/>
               <Route path={`${this.props.menu.desafios.duplicar}/:id`}                         component={DesafiosDuplicar}/>
               <Route path={`${this.props.menu.desafios.desafiobombaaction}/:id1/:id2`}         component={DesafioBombaAction}/>
               <Route path={`${this.props.menu.desafios.desafioquizaction}/:id1/:id2`}          component={DesafioQuizAction}/>
               <Route path={`${this.props.menu.desafios.desafiosenhaaction}/:id1/:id2`}         component={DesafioSenhaAction}/>

               <Route path={`${this.props.menu.questao}/:id`}                                   component={Questao}/>
               
               <Route path={`${this.props.menu.desafios.desafiobomba}/:id`}                     component={DesafioBomba}/>
               <Route path={`${this.props.menu.desafios.desafiosenha}/:id`}                     component={DesafioSenha}/>
               <Route path={`${this.props.menu.desafios.desafioquiz}/:id`}                      component={DesafioQuiz}/>
               <Route path={`${this.props.menu.desafios.desempenho}/:id`}                       component={DesempenhoAluno}/>               
               <Route path={`${this.props.menu.desafios.jogos}/:ati_id/:ati_tipo`}              component={DesafioJogos}/>
               <Route path={this.props.menu.missao.home}                                        component={MissaoProfessorDisciplina}/>
               <Route path={this.props.menu.missao.novo}                                        component={MissaoCadastro}/>
               <Route path={`${this.props.menu.missao.editar}/:tar_id`}                         component={MissaoEditar}/>
               <Route path={`${this.props.menu.missao.resposta}/:id1/:id2/:id3`}                component={MissaoResposta}/>
               <Route path={`${this.props.menu.missao.missao_lista}/:tur_id/:dis_id`}           component={MissaoLista}/>
               <Route path={this.props.menu.relatorio.home}                                     component={Relatorio}/>
               <Route path={this.props.menu.relatorio.rankingAluno}                             component={RankingAluno}/>
               <Route path={this.props.menu.relatorio.rankingTurma}                             component={RankingTurma}/>
               <Route path={this.props.menu.recursos.home}                                      component={Recursos}/>
               <Route path={this.props.menu.perfil.home}                                        component={Perfil}/>
               
            </div>
          </div>
       </div>
      </div>
      </Router>
    );
  }
}


function mapStateToProps(state){
  
      return {
               isAuthenticated   : state.auth.isAuthenticated,
               session           : state.auth.session,
               checkSelect     : state.scopoReducer.checkSelect,
               menu              : state.configReducer.menu,
               config            : state.configReducer.config
             };
  }
  
  export default connect(mapStateToProps,{GetCheckSelect})(home_professor);



// WEBPACK FOOTER //
// ./src/components/professor/home_professor/home_professor.js